// extracted by mini-css-extract-plugin
module.exports = {"policy":"styles_policy__gw7bn","link":"styles_link__1T0R2"};